import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgHttpLoaderModule } from "ng-http-loader";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from "./material/material.module";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanDetailsComponent } from './components/plan-details/plan-details.component';
import { DrugSearchComponent } from './components/drug-search/drug-search.component';
import { DrugResultsComponent } from './components/drug-results/drug-results.component';
import { ToastComponent } from './components/helpers/toast/toast.component';
import { HttpErrorInterceptor } from './services/http-error-interceptor';
import { DrugSearchDetailsComponent } from './components/drug-search-details/drug-search-details.component';

@NgModule({
  declarations: [
    AppComponent,
    PlanDetailsComponent,
    DrugSearchComponent,
    DrugResultsComponent,
    ToastComponent,
    DrugSearchDetailsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    MaterialModule,
    NgHttpLoaderModule.forRoot(),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule
  ],
  exports:[MaterialModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
